import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "button"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.openValue) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Close all other dropdowns first
    document.querySelectorAll('[data-controller~="dropdown"]').forEach(dropdown => {
      if (dropdown !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(dropdown, "dropdown")
        if (controller) controller.close()
      }
    })

    this.openValue = true
    this.menuTarget.classList.remove("hidden")

    // Add event listeners
    setTimeout(() => {
      document.addEventListener("click", this.boundCloseOnClickOutside)
      document.addEventListener("keydown", this.boundCloseOnEscape)
    }, 10)
  }

  close() {
    this.openValue = false
    this.menuTarget.classList.add("hidden")

    // Remove event listeners
    document.removeEventListener("click", this.boundCloseOnClickOutside)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
